/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { Button as ButtonComponent, ButtonProps as ButtonComponentProps, Spinner } from "reactstrap";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import * as styles from "./button.styles";

export interface ButtonProps extends ButtonComponentProps {
    icon?: FontAwesomeIconProps["icon"];
    rounded?: boolean;
    iconOnlyBreakpoint?: string;
    isInBottomBar?: boolean;
}

export const Button = ({ icon, iconOnlyBreakpoint, rounded, children, className, isInBottomBar, color, isLoading, ...props }: ButtonProps) => {
    const isIconOnly = !children && icon;
    const iconBreakpoint = isInBottomBar ? "md" : iconOnlyBreakpoint;

    return (
        <div className={`d-inline-flex flex-column gap-1 align-items-center ${className ?? ""}`} css={[isInBottomBar && styles.launcherStyles, isIconOnly && styles.iconOnlyStyles]}>
            <ButtonComponent
                className={`button text-nowrap d-flex align-items-center gap-2 justify-content-center ${isInBottomBar ? "" : "w-100"}`}
                css={rounded && styles.roundedStyles}
                color={color}
                {...props}
            >
                {isLoading && <Spinner size="sm" className="position-absolute" />}

                {icon && (
                // eslint-disable-next-line no-nested-ternary
                    <div className={`d-flex justify-content-center align-items-center ${isLoading ? "opacity-0" : ""}`} css={!!iconOnlyBreakpoint || !children ? css`height: ${props.size === "sm" ? 21 : props.size === "lg" ? 30 : 24}px;` : undefined}>
                        <FontAwesomeIcon icon={icon} />
                    </div>
                )}

                {children && (
                    <span className={`text-nowrap ${!!iconOnlyBreakpoint || isInBottomBar ? `d-none d-${iconBreakpoint}-flex` : ""} ${isLoading ? "opacity-0" : ""}`}>
                        {children}
                    </span>
                )}
            </ButtonComponent>

            {children && isInBottomBar && (
                <span className={`d-${iconBreakpoint}-none text-center`} css={css`font-size: 12px;`}>
                    {children}
                </span>
            )}
        </div>
    );
};
